<template>



<section class="container section-large result-container mbl" :class="{ circleResultsAnimTwo: resultsClassOnOff }">

    <div class="is-flex is-align-items-center is-justify-content-center mb" :class="{ circleResultsAnim: resultsClassOnOff }">
        <q-circular-progress
        id="results" 
        show-value
        :value="circleScore"
        animation-speed="3500"
        :thickness="0.15"
        color="shade"
        track-color="grey-3"
        >
            <div class="circular-progress-text">
                <div v-if="weightedAvClassTitle != 'Incalculable' && weightedAvClassTitle != '120 credits required' && weightedAvClassTitle != '120 credits required for level 5 & 4'">
                    <h2>{{ weightedAvClassTitle }}</h2>
                    <hr>
                    <h2>
                        <span>{{ weightedAvClass.toFixed(2) }}</span>
                    </h2>
                </div>
                <div v-else>
                    <h2>{{ weightedAvClassTitle }}</h2>
                </div>
            </div>
        </q-circular-progress>
    </div> 

    <div class="certificationGridColumn" :class="{circleResultsAnimTwo: resultsClassOnOff }">


            <div class="results-methods"> 
                <div class="methods">
                    <h2>Method</h2>
                    <div class="stats-container"> 
                        <div class="stats-container-flex">
                            <p class="cert-info-fin">How your classification is calculated
                                <q-icon
                                tabindex="0"
                                @click="openCloseModal = true ; disableBackgroundScroll()"
                                @keydown.enter="openCloseModal = true ; disableBackgroundScroll()"
                                class="pulsing-help-btn"
                                size="md"
                                name="info"
                                />
                            </p>
                            <Teleport to="body">
                                <Dialog @closeModal="closeModalBtn" v-if="openCloseModal">
                                    <template v-slot:header >
                                    How your classification is calculated
                                    </template>
                                    <template v-slot:content >
                                        <p>Your Foundation Degree is calculated based on the weighted average from your units at Level 5. The weighted averages are formed by combining the marks for each unit at that level according to the credit values of your units.</p>
                                
                                        <p>For an award to be made at <b>pass</b> level, you must pass or otherwise be credited with all of the units that make up the specified number and level of credits for the award. A unit shall be passed at level 5 when you achieve a weighted average mark of 40% or more for the summative assessment(s) associated with the unit</p>
                                
                                        <p>For an award to be made with <b>merit</b>, a student must achieve a weighted average of at least 60% in those units studied at the highest level for the specified award.</p>
                                
                                        <p>For an award to be made with <b>distinction</b>, a student must achieve a weighted average of at least 70% in those units studied at the highest level for the specified award.</p>

                                        <p>Full details of how this method is calculated can be found in the <a target="blank" href="https://www.mmu.ac.uk/sites/default/files/2022-10/2223%20Undergraduate%20Assessment%20Regulations.pdf">Assessment Regulations</a>.</p>     
                                
                                    </template>
                                </Dialog>
                            </Teleport>
                        </div>

                    </div>
                </div>  
            </div>

            <div class="results-final">

                <div >
                    <div>
                        <h2>Final Result</h2>

                        <div class="final-grade-layout"> 
                                <div class="stats-container-flex">
                                    <h3>Classification</h3>
                                    <p class="cert-info-fin">{{ weightedAvClassTitle }}</p>
                                </div>

                                <div class="stats-container-flex">
                                    <div v-if="weightedAvClassTitle === 'Incalculable' || weightedAvClassTitle === '120 credits required'">
                                        <h3>Mark</h3>
                                        <p class="cert-info-fin">{{ weightedAvClassTitle }}</p>
                                    </div>
                                    <div v-else>
                                        <h3>Mark</h3>
                                        <p class="cert-info-fin">{{ weightedAvClass.toFixed(2) }}</p>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <button title="Copy to clipboard" class="button is-large mts" @click="clipboard"><q-icon left name="content_copy"/>Copy to clipboard</button>
</section>

</template>

<script>
import { copyToClipboard } from 'quasar'
import { useQuasar } from 'quasar'
import { ref } from 'vue'
import Dialog from '@/components/Dialog.vue'

export default {

components: { Dialog },

props: ['resultsClassOnOff', 'weightedAvClassTitle','levelFiveFinalGrade', 'weightedAvClass', 'methodOne', 'circleScore', 'methodSwitch', 'finalScore', 'component'],

setup(props, context){

const openCloseModal = ref(false)
const quasar = useQuasar()

quasar.notify.setDefaults({
    actions: [{ icon: 'close', color: 'white' }]
})

const closeModalBtn = () => {
    openCloseModal.value = false
    
    if( openCloseModal.value === false ) {
        document.documentElement.style.overflowY = 'scroll';
        document.documentElement.style.overflowX = 'hidden';
        document.body.scroll = "yes";     
    } 
}

const disableBackgroundScroll = () => {

    if( openCloseModal.value === true ) {
        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = "no";
    } 
}

const clipboard = () => {
  
    let pasteContent = 
    // ref(`FINAL RESULT: ${props.weightedAvClassTitle}, ${props.finalScore.toFixed(2)};`)

    ref(`FINAL RESULT: ${props.weightedAvClassTitle}${props.weightedAvClassTitle === "120 credits required" || props.weightedAvClassTitle === "Incalculable" ? "" : ', ' + props.finalScore.toFixed(2)};`)

    copyToClipboard(pasteContent.value)
    .then(() => { 
        quasar.notify({
        color: 'negative', message: 'You can now paste your grade wherever you like!', icon: 'content_paste_go', position: 'bottom', classes: 'notify-copy'
        })
    })
    .catch(() => {
        quasar.notify({
        color: 'negative', message: 'Something went wrong, try again!', icon: 'error', position: 'bottom', classes: 'notify-copy'
        })
    })
}

return {        
     clipboard,
     quasar,
     closeModalBtn,
     openCloseModal,
     disableBackgroundScroll
}

}
}
</script>

<style>

</style>